<template>
  <div>
    <div class="flex text-zt-primary-600 p-4 text-lg">
      <zt-icon name="file-pen-alt" />
      <p class="pl-2"> {{ $t('message.dashboard.pendingFirm') }}</p>
    </div>

    <div :class="{'flex justify-center': !dashboard, 'flex flex-col align-center': dashboard}">
      <div class="graphic-size p-2">
        <selectedFile />
      </div>
      <div :class="{'flex': dashboard, 'contents':!dashboard}" >
        <div class=" cursor-pointer px-4 text-center" data-vs-button="btn-documents"
          @click="$router.push('/documents')">
          <h2 class="text-3xl font-bold">{{ documentsData.manager_awaiting_signature }}</h2>
          <p class="text-xl">{{ $t('message.dashboard.mine') }}</p>
        </div>
        <div class="px-4 text-center" data-vs-button="btn-documentSearch" :class="{ 'cursor-pointer': !isMobile }"
          @click="getTeamDocuments">
          <h2 class="text-3xl font-bold">{{ documentsData.team_awaiting_signature }}</h2>
          <p class="text-xl">{{ $t('message.dashboard.teams') }}</p>
        </div>
      </div>

    </div>
    <div class="flex justify-end text-zt-primary-200 p-4 text-md" v-if="false">
      <p class="pl-2">{{ $t('message.dashboard.sendReminder') }}</p>
      <zt-icon name="sound" />
    </div>
  </div>
</template>

<script>
import selectedFile from '@/components/commons/Illustrations/graphicSVG/selectedInvoiceSVG'
import { useWindowResize } from '@sichern/ui-elements'
import Manager from "@/apiClient/Manager"

export default {
  name: "SignDocuments",
  components: {
    selectedFile
  },
  props: {
    documentsData: Object,
    dashboard: Boolean
  },
  data() {
    return {
      manager: Manager,
      windowResize: useWindowResize(this),
    }
  },

  computed: {
    isMobile() {
      return this.windowResize.width < 1024
    },
  },
  methods: {

    getTeamDocuments() {
      if (!this.isMobile) {
        this.$router.push({ name: 'documents-search', params: { loadUnsignedDocs: true } });
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.contents {
  display: contents;
}
</style>